import debounce from 'lodash/debounce';

import { AnalyticEventName, track } from 'src/core/utils/analytics';

export const trackRequestsSearchText = debounce((textFilter) => {
  track(AnalyticEventName.REQUESTS_LIST_SEARCH_CHANGED, {
    value: textFilter,
  });
}, 700);
